module.exports = __webpack_public_path__ + "static/media/studio_electric_forklift_truck_me_315_manitou_001.4fb65236.png";